import React from 'react'
import { PromoCodeUsageList } from './list/page'

export const PromoCodesUsagePage: React.FC = () => {
  return <PromoCodeUsageList />
}
